import React, { Component } from "react";
import { connect } from "react-redux";
import Immutable from "immutable";
import FontAwesome from "react-fontawesome";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import {
  showHideModalAdicionarCencos,
  actualizarDistribuciones
} from "../actions";
import {
  showHideModalSelector,
  selectFromSelector
} from "../../Layout/actions";

class ModalAdicionarCenco extends Component {
  handleOpenSelector = (columns, reducer, path) => {
    const payload = {};
    const fn = a => {
      payload.reducer = reducer;
      payload.path = path;
      payload.value = Immutable.fromJS(a);
      this.props.selectFromSelector(payload);
    };
    this.props.showHideModalSelector(
      true,
      "Listado de centros de costo",
      "Cenco",
      columns,
      fn,
      ["aprobador", "presupuesto"]
    );
  };

  modalContent = () => {
    return (
      <form
        id="form"
        onSubmit={e => {
          e.preventDefault();
          this.props.actualizarDistribuciones();
        }}
        noValidate
      >
        <ButtonStrip
          actions={[
            <BoxButton
              key="ba[-1][0]"
              name="check"
              title="Aceptar"
              disabled={this.props.saving}
            />
          ]}
        />
        <div>
          <div className="row">
            <div className="col-md-8">
              <div className="form-group">
                <label className="control-label">Centro de costo</label>
                <Input
                  type="selector"
                  reducer="nuevasolicitud"
                  path="modalAdicionarCenco.data.cenco.codigo"
                  onClick={() =>
                    this.handleOpenSelector(
                      [
                        {
                          id: 1,
                          caption: "Código",
                          value: "codigo",
                          width: "20%"
                        },
                        {
                          id: 2,
                          caption: "Nombre",
                          value: "nombre",
                          width: "30%"
                        },
                        {
                          id: 3,
                          caption: "Aprobador",
                          value: "aprobador.name",
                          width: "50%"
                        }
                      ],
                      "nuevasolicitud",
                      "modalAdicionarCenco.data.cenco"
                    )
                  }
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="control-label">Porcentaje, %</label>
                <Input
                  type="number"
                  reducer="nuevasolicitud"
                  path="modalAdicionarCenco.data.porcentaje"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { modalAdicionarCenco } = this.props;

    return (
      <Modal
        ancho="400px"
        mostrar={modalAdicionarCenco.get("show")}
        contenido={this.modalContent()}
        titulo="Actualización de distribuciones en centros de costo"
        nombre="modal_adicionar_cenco_solicitud"
        onCerrarModal={() => this.props.showHideModalAdicionarCencos(false)}
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalAdicionarCenco: state.nuevasolicitud.get("modalAdicionarCenco")
  };
};

const mapDispatchToProps = {
  showHideModalAdicionarCencos,
  actualizarDistribuciones,
  showHideModalSelector,
  selectFromSelector
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalAdicionarCenco);
